import { render, staticRenderFns } from "./FormErrorTeaching.vue?vue&type=template&id=147fd7fb"
import script from "./FormErrorTeaching.vue?vue&type=script&lang=js"
export * from "./FormErrorTeaching.vue?vue&type=script&lang=js"
import style0 from "./FormErrorTeaching.vue?vue&type=style&index=0&id=147fd7fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports